export enum VatScheme {
  AccrualBased = 1,
  CashBased = 2,
  FlatRateAccrualScheme = 3,
  FlatRateCashBasedScheme = 4,
  PartialExemptionScheme = 5,
  RetailScheme = 6,
  AnnualAccountingScheme = 7,
}
